import React, { Fragment, useContext, useRef, useEffect } from "react";
import { Grid, Divider, OutlinedInput, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookProfilesDashboardContext from "../../../context/facebook_profiles/dashboard/DashboardContext";

// Components

const useStyles = makeStyles((theme) => ({
  input: {
    fontSize: "0.9rem",
    backgroundColor: "white",
  },
  buttonBox: {
    textAlign: "center",
    marginLeft: "0.5rem",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
  button2: {
    color: "white",
    backgroundColor: "#dc004e",
    "&:hover": {
      backgroundColor: "#dc004e",
    },
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const DashboardActions = () => {
  const classes = useStyles();

  const {
    selected_profile,
    profile_form,
    setProfile,
    profiles_filtered,
    filterProfiles,
    clearFilteredProfiles,
    toggle_ads,
    setToggleAds,
    display_content,
  } = useContext(FacebookProfilesDashboardContext);

  const searchText = useRef("");

  const changeRoute = (action) => {
    // Append "action" to URL Without Reload
    const html = document.getElementById("root").innerHTML;
    const pageTitle = document.title;
    const urlPath = window.location.href + `/${action}`;

    if (!window.location.pathname.includes(`/${action}`)) {
      window.history.pushState(
        {
          html,
          pageTitle,
        },
        "",
        urlPath
      );
    }
  };

  const editProfile = () => {
    setProfile({ ...profile_form, action: "Edit" });
    changeRoute("edit");
  };

  const createProfile = () => {
    setProfile({ ...profile_form, action: "Create" });
    changeRoute("create");
  };

  const deleteProfile = () => {
    setProfile({ ...profile_form, action: "Delete" });
  };

  const searchProfile = (e) => {
    if (searchText.current.value) {
      searchText.current.value = searchText.current.value
        .toUpperCase()
        .replace(/ /g, "");

      filterProfiles(e.target.value.replace(/[^\w\s]/gi, ""));
    } else {
      clearFilteredProfiles();
    }
  };

  useEffect(() => {
    if (!profiles_filtered) searchText.current.value = "";
  });

  return (
    <Fragment>
      <Grid item xs={12}>
        <Divider variant="fullWidth" />
      </Grid>
      <Grid item xs={12} container>
        {/* Search Bar */}
        <Grid
          item
          xs={2}
          container
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item xs={12}>
            <OutlinedInput
              fullWidth
              type="text"
              margin="dense"
              className={classes.input}
              id="search_text"
              placeholder="Profile ID"
              autoFocus
              inputRef={searchText}
              onChange={searchProfile}
            />
          </Grid>
        </Grid>
        
        {/* <Grid item xs={2} container justifyContent="flex-start" align="center">
          {selected_profile && !display_content ? (
            <Grid item className={classes.buttonBox}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={() => setToggleAds(!toggle_ads)}
              >
                {toggle_ads ? "Business Info" : "Ads Manager"}
              </Button>
            </Grid>
          ) : null}
        </Grid> */}
        
        <Grid item xs container justifyContent="flex-end" alignItems="center">
          {/* <Grid item></Grid> */}
          {selected_profile ? (
            <Grid item className={classes.buttonBox}>
              <Button
                fullWidth
                variant="contained"
                className={classes.button2}
                onClick={deleteProfile}
              >
                Delete Profile
              </Button>
            </Grid>
          ) : null}
          <Grid item className={classes.buttonBox}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={selected_profile ? editProfile : createProfile}
            >
              {selected_profile ? "Edit Profile" : "Create Profile"}
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider variant="fullWidth" />
      </Grid>
    </Fragment>
  );
};

export default DashboardActions;
